import request from './../../utilities/request';
import localStorageToken from './../../utilities/storage';

function get(page) {
  return request({
    url:    `/poll/list/page/${ page }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function create(values) {
  return request({
    url:    '/poll/save',
    headers: {'Authorization': localStorageToken()},
    method: 'POST',
    data:   values
  });
}

function update(id, values) {
  return request({
    url:    `/poll/update/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'PUT',
    data:   values
  });
}

function find(id) {
  return request({
    url:    `/poll/overview/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function questions(id) {
  return request({
    url:    `/poll/questions/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function saveQuestion(values) {
  return request({
    url:    '/poll/question/save',
    headers: {'Authorization': localStorageToken()},
    method: 'POST',
    data:   values
  });
}

function removeQuestion(id) {
  return request({
    url:    `/poll/question/remove/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'DELETE'
  });
}

function report(id) {
  return request({
    url:    `/poll/results/list/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function importUsers(values) {
  return request({
    url:    `/poll/user/import`,
    headers: {'Authorization': localStorageToken()},
    method: 'POST',
    data:   values
  });
}

function reportAll() {
  return request({
    url:    `/poll/report/all`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

const PollService = {
  get, create, update, find, questions, saveQuestion, removeQuestion, report, reportAll, importUsers
}

export default PollService;
